"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHotkeys = require("react-hotkeys");

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

var _ratio = require("../services/ratio/ratio.service");

var _ratio2 = _interopRequireDefault(require("./shapes/ratio.shape"));

var _knownAxis = _interopRequireDefault(require("./shapes/known-axis.shape"));

var _aspectRatioBox = _interopRequireDefault(require("../aspect-ratio-box/aspect-ratio-box"));

var _fullscreen = _interopRequireDefault(require("../fullscreener/fullscreen.service"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

class VideoPlayer extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      duration: undefined,
      knownAxis: this.props.knownAxis === 'auto' ? 'width' : this.props.knownAxis
    });
    (0, _defineProperty2.default)(this, "setAutoAxis", () => {
      let knownAxis;

      if (this.props.knownAxis === 'auto') {
        const containerParent = this.container.parentElement;
        const parentBox = containerParent.getBoundingClientRect();
        const parentRatio = parentBox.width / parentBox.height;
        const [ratioWidth, ratioHeight] = this.getRatioNumbers();
        const containerRatio = ratioWidth / ratioHeight;
        const isParentRatioBigger = parentRatio > containerRatio;
        knownAxis = isParentRatioBigger ? 'height' : 'width';
      } else {
        knownAxis = this.props.knownAxis;
      }

      if (knownAxis !== this.state.knownAxis) {
        this.setState({
          knownAxis
        });
      }
    });
    (0, _defineProperty2.default)(this, "onMetadata", () => {
      this.setState({
        duration: this.videoTag.duration * 1000
      });
    });
    (0, _defineProperty2.default)(this, "getRatioNumbers", () => {
      const [ratioWidth, ratioHeight] = this.props.ratio.split(':');
      return [+ratioWidth, +ratioHeight];
    });
    (0, _defineProperty2.default)(this, "videoLoaded", () => {
      const {
        onLoaded
      } = this.props.callbacks;
      onLoaded && onLoaded();
    });
    (0, _reactHotkeys.configure)({
      ignoreRepeatedEventsWhenKeyHeldDown: false
    }); // configuring react-hotkeys for fixing "keypress" functionality
  }

  componentDidMount() {
    const {
      onInit
    } = this.props.callbacks;
    const {
      rendered
    } = this.state;

    if (!rendered) {
      this.setState({
        rendered: true
      });
      onInit && onInit();
    } // we only get duration when video has enough metadata loaded; Sometimes video is in cache so it's already there on didMount


    if (this.videoTag) {
      if (this.videoTag.duration) {
        this.onMetadata();
      }

      this.videoTag.addEventListener('loadedmetadata', this.onMetadata);
      this.setAutoAxis();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.videoUrl !== this.props.videoUrl) {
      this.setState({
        duration: undefined
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ratio !== this.props.ratio || prevProps.knownAxis !== this.props.knownAxis) {
      this.setAutoAxis();
    }
  }

  componentWillUnmount() {
    if (this.videoTag) {
      this.videoTag.removeEventListener('loadedmetadata', this.onMetadata);
    }
  }
  /**
   * setAutoAxis calculates and sets the `knownAxis` state based on aspect ratio of the video vs. its container's ratio
   *
   * For containers of any/unknown dimensions, setting knownAxis to 'auto' will use this method
   * @example A 16:9 video in a 16:10 (taller) container:
   * @example     Video's AR is 1.77 and container's is 1.6 - Which is smaller, so video will stretch its width
   * @example A 9:16 video in a 16:9 container - 0.56 vs. 1.77:
   * @example     Container has a bigger ratio, stretching width will overflow the container so video should fill the height axis
   *
   * @memberof VideoPlayer
   */


  render() {
    const {
      videoUrl,
      ratio,
      autoplay,
      loop,
      muted
    } = this.props;
    const _this$props = this.props,
          {
      children,
      duration,
      callbacks
    } = _this$props,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "duration", "callbacks"]);
    const {
      knownAxis
    } = this.state;

    const childrenProps = _objectSpread({
      videoTag: this.videoTag,
      container: this.container,
      duration: this.state.duration,
      callbacks
    }, otherProps);

    if (callbacks.onShare) {
      // if we have an onShare callbacks, wrap it
      const originalOnShare = callbacks.onShare;

      callbacks.onShare = () => {
        originalOnShare(); // in addition to calling the callback, make sure we're not fullscreen

        _fullscreen.default.exit(this.container).catch(() => {});
      };
    }

    const ChildrenWithProps = children ? /*#__PURE__*/_react.default.cloneElement(children, childrenProps) : null;
    const [ratioWidth, ratioHeight] = this.getRatioNumbers();
    return /*#__PURE__*/_react.default.createElement(_aspectRatioBox.default, {
      width: ratioWidth,
      height: ratioHeight,
      knownAxis: knownAxis,
      className: (0, _classnames.default)('video-player-container', "video-player-container--ratio-".concat(_ratio.RATIOS[ratio].name), "video-player-container--known-".concat(knownAxis)),
      ref: container => {
        this.container = container;
      }
    }, /*#__PURE__*/_react.default.createElement(_reactResizeDetector.default, {
      handleWidth: true,
      handleHeight: true,
      onResize: this.setAutoAxis
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("video", {
      src: videoUrl,
      ref: videoTag => {
        this.videoTag = videoTag;
      },
      autoPlay: autoplay,
      loop: loop,
      muted: muted,
      playsInline: true
    }), ChildrenWithProps));
  }

}

(0, _defineProperty2.default)(VideoPlayer, "propTypes", {
  children: _propTypes.default.node,
  videoUrl: _propTypes.default.string,
  // can't require as sometimes its passed later with children
  ratio: _ratio2.default,
  resolution: _propTypes.default.number,
  duration: _propTypes.default.number,
  // also can't require
  callbacks: _propTypes.default.shape({
    onInit: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    onShare: _propTypes.default.func,
    onLoaded: _propTypes.default.func
  }),
  knownAxis: _knownAxis.default,
  autoplay: _propTypes.default.bool,
  loop: _propTypes.default.bool,
  muted: _propTypes.default.bool
});
(0, _defineProperty2.default)(VideoPlayer, "defaultProps", {
  children: null,
  ratio: _ratio.RATIOS_BY_NAME.wide.key,
  resolution: _ratio.RATIOS_BY_NAME.wide.height,
  videoUrl: '',
  duration: undefined,
  callbacks: {},
  knownAxis: 'auto',
  autoplay: false,
  loop: false,
  muted: false
});
var _default = VideoPlayer;
exports.default = _default;